import FilterPagesGeneral from "../../components/FilterPagesGeneral";

export default function MyCommissions() {
  const filterMethods = ["status", "issue_date"];
  const buttons = ["export_report"];

  return (
    <FilterPagesGeneral
      pageName={"commissions"}
      filterMethods={filterMethods}
      buttonTypes={buttons}
    />
  );
}
